import { checkinApi } from '@/services/api/httpClient';

const ocrActions = {
  async sendFilesToOcr({ getters }, { files, admissionId, unitId }) {
    const url = `/ocr/validate-medical-orders`;
    const hasExams = getters.haveScheduledExams.status;

    try {
      const response = await checkinApi().post(url, {
        admissionId: admissionId,
        unitId: unitId,
        updateAdmission: !hasExams,
        files: files,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao enviar arquivos para OCR (nova rota):', error);
      return null;
    }
  },
  async createMedicalOrderByOcr({ getters }, { exams, clientId, unitId, negotiationVariables }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `admission/${admissionId}/ocr/medical-order`;

    try {
      const response = await checkinApi().post(url, {
        exams,
        clientId,
        unitId,
        negotiationVariables,
      });

      return response.data;
    } catch (error) {
      console.error('Erro ao criar pedido médico via OCR:', error);
      return null;
    }
  },
  async updateMedicalOrderUrl({ getters }, { admissionId, idPaperless }) {
    const url = `/admission/${admissionId}/url-medical-order`;

    try {
      const response = await checkinApi().patch(url, {
        idPaperless,
      });

      return response.data;
    } catch (error) {
      return null;
    }
  },
};
export default ocrActions;
